import { useCmsOrderedSubscriptions } from "../../../../hooks/use-cms-ordered-subscriptions/use-cms-ordered-subscriptions";
import { useCurrentUserSubscriptionTier } from "../../../../hooks/use-current-user-subscription-tier/use-current-user-subscription-tier";
import type { ICmsSubscription } from "../../../../services/cms-subscription/entities/cms-subscription/cms-subscription.entity.interface";

export function useIsChatbotAvailableToUser(): boolean {
  const { currentUserTier } = useCurrentUserSubscriptionTier();
  const cmsOrderedSubscriptions = useCmsOrderedSubscriptions();

  const isChatbotAvailableToUserTier = cmsOrderedSubscriptions?.some(
    function checkIfCurrentUserSubscriptionHasAiEnabled(subscription: ICmsSubscription) {
      return subscription.externalProviderCode.toLowerCase() === currentUserTier.toLowerCase() && subscription.hasAI;
    }
  );

  return isChatbotAvailableToUserTier ?? false;
}
